// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/abs/views/home/component/index.less
// module id = 810
// module chunks = 42